<template>
  <div id="app"
    :style="{
      overflow: mainAppFixedFlag ? 'hidden' : 'auto',
      height: mainAppFixedFlag ? '100vh' : 'auto',
    }"
  >
    <HeaderBar
      preHref="https://udn.com/newmedia/921/"
      pageName=""
      facebookShareURL="https://udn.com/newmedia/921/en/"
      lineShareURL="https://udn.com/newmedia/921/en/"
    />
    <ProgressBar
      :PAGE_AMOUNT="PAGE_AMOUNT"
      :currentPage="currentPage"
    />
    <div
      id="main-app"
      class="main-app"
    >
      <NormalPage
        :PAGE_INDEX="13"
        :PAGE_AMOUNT="PAGE_AMOUNT"
        :currentPage="currentPage"
        :scrollDownArrowFlag="scrollDownArrowFlag"
      >
        <div class="full-vidoe-wrapper" slot="background">
          <video
            ref="page13VideoRef"
            class="ending-video"
            :src="isMob ? 'https://p3.udn.com.tw/921/main/921_pageEnd_video2_mob.mp4' : 'https://p3.udn.com.tw/921/main/921_page_End_video_web20190731.mp4'"
            width="100%"
            webkit-playsinline
            playsinline
            muted
          />
        </div>
        <div class="page-13-content text-white" slot="content">
          <div :class="{
            'page-13-text': true,
            'page-13-text-animation-1': page13Config.contentFlag,
            }"
          >
            <div class="page-13-text-align-left">
              <p>In 2019,</p>
              <p>if the quake comes, it is predicted that</p>
            </div>
          </div>
          <div :class="{
            'page-13-text': true,
            'page-13-text-animation-2': page13Config.contentFlag,
            }"
          >
            <div class="page-13-text-align-left">
              <p>3,664 lives could be at risk.</p>
              <p>32,775 buildings could collapse.</p>
            </div>
          </div>
          <div :class="{
            'page-13-text-2': true,
            'page-13-text-animation-3': page13Config.contentFlag,
            }"
          >
            <div class="page-13-text-align-left">
              <p>How many 20 years</p>
              <p>could Taiwan have to recover and to stand back on our feet again?</p>
            </div>
          </div>
          <div class="source-text-wrapper">
            <div class="source-text">
              Source:
            </div>
            <div class="source-text">
              National Center for Research on Earthquake Engineering
            </div>
          </div>
        </div>
      </NormalPage>
      <NormalPage
        :PAGE_INDEX="12"
        :PAGE_AMOUNT="PAGE_AMOUNT"
        :currentPage="currentPage"
        :scrollDownArrowFlag="scrollDownArrowFlag"
      >
        <div class="page-12-background" slot="background">
          <img
            class="page-12-background-image page-12-background-animation-1"
            :src="require('./assets/images/page11/921_redRound_3.svg')"
            alt="紅色光球"
          >
          <img
            class="page-12-background-image page-12-background-animation-2"
            :src="require('./assets/images/page11/921_redRound_3.svg')"
            alt="紅色光球"
          >
          <img
            class="page-12-background-image page-12-background-animation-3"
            :src="require('./assets/images/page11/921_redRound_3.svg')"
            alt="紅色光球"
          >
        </div>
        <div class="page-12-content text-white" slot="content">
          <p>In 2019, Taiwan still has</p>
          <p><br></p>
          <div class="red-round-text-wrapper">
            <div class="red-round-text-1">
              <h2>4.1 <span v-if="!isMob"><br></span>million households</h2>
              <p>occupies the buildings over 30 year-old.</p>
            </div>
            <div class="red-round-text-1">
              <h2>48429 <span v-if="!isMob"><br></span>buildings</h2>
              <p>were built nearby faults in Taiwan. </p>
            </div>
            <div class="red-round-text-2">
              <h2>2517 <span v-if="!isMob"><br></span>public buildings</h2>
              <p>were in dangerous status.</p>
            </div>
          </div>
          <p><br></p>
          <p>They are all not fixed, once an earthquake hit, <span v-if="isMob"><br></span> would they stand?</p>
          <p class="read-more-button-red" @click="sendOutlinkButtonGA('檢測你的家')"><a href="./safehome/" target="_blank">Check your house</a></p>
        </div>
      </NormalPage>
      <NormalPage
        :PAGE_INDEX="11"
        :PAGE_AMOUNT="PAGE_AMOUNT"
        :currentPage="currentPage"
        :scrollDownArrowFlag="scrollDownArrowFlag"
      >
        <div class="page-11-background" slot="background">
          <img :class="{
              'page-11-background-image': true,
              'page-11-background-animation-1': page11Config.bgFlag,
            }"
            :src="require(isMob ? './assets/images/page10/921_page_background3.jpg' : './assets/images/page10/web/921_page_background3_pc.jpg')" alt="921大地震照片"
          >
          <img :class="{
              'page-11-background-image': true,
              'page-11-background-animation-2': page11Config.bgFlag,
            }"
            :src="require(isMob ? './assets/images/page10/921_page_background4.jpg' : './assets/images/page10/web/921_page_background4_pc.jpg')" alt="921大地震照片"
          >
        </div>
        <div class="page-11-content text-white" slot="content">
          <p>17 years later, 2016 Tainan quake hit.</p>
          <p>The collapsed Weiguan Jinlong residential complex in Tainan was found with bad construction quality.</p>
          <p>This quake took 115 lives.</p>
          <br>
          <p>18 years later, 2017 Hualien earthquake hit.</p>
          <p>The bad construction quality once again took 17 lives.</p>
        </div>
      </NormalPage>
      <NormalPage
        :PAGE_INDEX="10"
        :PAGE_AMOUNT="PAGE_AMOUNT"
        :currentPage="currentPage"
        :scrollDownArrowFlag="scrollDownArrowFlag"
      >
        <div class="page-10-background" slot="background">
          <img :class="{
              'page-10-background-image': true,
              'page-10-background-animation': page10Config.bgFlag,
            }"
            :src="require('./assets/images/page9/921_page_background2.jpg')"
            alt="921大地震照片"
          >
        </div>
        <div class="page-10-content text-white" slot="content">
          <p>The images of the fallen buildings are still vivid in our eyes.</p>
          <div class="page-10-text-2">
            <p>The steel bars are loose. </p>
            <p>The concrete quality is bad.</p>
            <p>And the foundation is soft.</p>
          </div>
          <br>
          <p>Our homes were not earthquake resistant at all. </p>
        </div>
      </NormalPage>
      <NormalPage
        :PAGE_INDEX="9"
        :PAGE_AMOUNT="PAGE_AMOUNT"
        :currentPage="currentPage"
        :scrollDownArrowFlag="scrollDownArrowFlag"
        :bgColor="page9Config.bgColor"
      >
        <div class="page-9-background"
          :style="{
            backgroundImage: 'url(' + require('./assets/images/page8/921_page_image_paper.jpg') + ')',
          }"
          slot="background"
        >
          <div class="black-filter"></div>
        </div>
        <div class="page-9-content text-white" slot="content">
          <div class="dynamic-bg-text-wrapper">
            <div class="dynamic-bg-text">
              <div :class="{
                'text-highlight': true,
                'text-highlight-animation': page9Config.contentFlag,
                }"
              ></div>
              <div class="text">
                <h4 style="color: #000000">What did the government do?</h4>
              </div>
            </div>
          </div>
          <h4>Apparently, the lost of <strong style="color: #c3dddd">2415 lives</strong> was not painful enough, the government still put our lives and property at stake.</h4>
          <p class="read-more-button-green" @click="sendOutlinkButtonGA('調查報導')"><a href="./live/" target="_blank">Our investigation</a></p>
          <div :class="{
            'page-9-content-img-wrapper': true,
            'content-image-animation': page9Config.contentFlag,
            }"
          >
            <img width="100%" class="page-9-background-image" :src="require('./assets/images/page8/921_page_image_paper.jpg')" alt="921報紙">
          </div>
        </div>
      </NormalPage>
      <NormalPage
        :PAGE_INDEX="8"
        :PAGE_AMOUNT="PAGE_AMOUNT"
        :currentPage="currentPage"
        :scrollDownArrowFlag="scrollDownArrowFlag"
        :bgColor="page8Config.bgColor"
      >
        <div class="page-8-background" slot="background">
          <div class="page-8-background-wrapper">
            <div class="map-wrapper">
              <Map921 :mapFlag="page8Config.mapFlag"></Map921>
            </div>
          </div>
        </div>
        <div class="page-8-content text-black" slot="content">
          <div class="page-8-content-text-1">
            <p>The victims protect Taiwan in their land.<br>A group of scientists choose to protect Taiwan in their labs.</p>
            <br>
            <p>Today, the seconds we can react to disaster increased.</p>
            <p><br></p>
            <p class="read-more-button-green" @click="sendOutlinkButtonGA('然後呢')"><a href="./resilientcity/" target="_blank">Read more</a></p>
          </div>
          <div class="source-text-wrapper">
            <div class="source-text">
              Data source:
            </div>
            <div class="source-text">
              Central Weather Bureau, National Center for Research on Earthquake Engineering
            </div>
          </div>
        </div>
      </NormalPage>
      <NormalPage
        :PAGE_INDEX="7"
        :PAGE_AMOUNT="PAGE_AMOUNT"
        :currentPage="currentPage"
        :scrollDownArrowFlag="scrollDownArrowFlag"
        :bgColor="page7Config.bgColor"
      >
        <div class="page-7-background" slot="background">
          <div :class="{
            'page-7-background': true,
            'page-7-background-animation': currentPage === 8,
            }"
          >
            <img class="page-7-background-image"
              :src="require('./assets/images/page7/921_green_Round.svg')"
              alt="綠色背景"
            >
            <img class="page-7-background-image-web-1"
              :src="require('./assets/images/page7/921_green_Round02.svg')"
              alt="綠色背景"
            >
            <img class="page-7-background-image-web-2"
              :src="require('./assets/images/page7/921_green_Round03.svg')"
              alt="綠色背景"
            >
          </div>
        </div>
        <div class="page-7-content text-black" slot="content">
          <div class="page-7-content-text-1 text-white">
            <p>During the twenty years,<span v-if="!isMob"><br></span>there were so many changes happend.</p>
          </div>
          <div class="page-7-content-text-2">
            <div class="dynamic-text-wrapper">
              <p class="dynamic-text">{{page7Config.dynamicDigit_1}}+</p>
              <p class="dynamic-text-sub">Community organization established after the earthquake.</p>
              <p>In Taiwan,2019 is defined as the first year of local placemaking, however, the victims have been doing this from two decades ago.</p>
            </div>
            <div class="dynamic-text-wrapper">
              <p class="dynamic-text">{{page7Config.dynamicDigit_2}}</p>
              <p class="dynamic-text-sub">Schools were reconstructed.</p>
              <p>An action called <strong> ”New school yard” </strong>made millions of students could learn in their neighborhood safely.</p>
            </div>
          </div>
        </div>
      </NormalPage>
      <NormalPage
        :PAGE_INDEX="6"
        :PAGE_AMOUNT="PAGE_AMOUNT"
        :currentPage="currentPage"
        :scrollDownArrowFlag="scrollDownArrowFlag"
        :bgColor="page6Config.bgColor"
      >
        <div class="page-6-background" slot="background">
          <img :class="{
            'page-6-background-img': true,
            'page-6-background-img-animation-5': page6Config.bgFlag,
            }"
            :src="require('./assets/images/page6/921_page_rebuild5.png')"
            alt="921二十周年"
          >
          <img :class="{
            'page-6-background-img': true,
            'page-6-background-img-animation-4': page6Config.bgFlag,
            }"
            :src="require('./assets/images/page6/921_page_rebuild4.png')"
            alt="921二十周年"
          >
          <img :class="{
            'page-6-background-img': true,
            'page-6-background-img-animation-3': page6Config.bgFlag,
            }"
            :src="require('./assets/images/page6/921_page_rebuild3.png')"
            alt="921二十周年"
          >
          <img :class="{
            'page-6-background-img': true,
            'page-6-background-img-animation-2': page6Config.bgFlag,
            }"
            :src="require('./assets/images/page6/921_page_rebuild2.png')"
            alt="921二十周年"
          >
          <img :class="{
            'page-6-background-img': true,
            'page-6-background-img-animation-1': page6Config.bgFlag,
            }"
            :src="require('./assets/images/page6/921_page_rebuild1.png')"
            alt="921二十周年"
          >
        </div>
        <div class="page-6-content text-black" slot="content">
          <div class="page-6-content-text">
            <p>
              They rooted their lives into the ground.
              <span v-if="isMob"><br></span>
              They don’t move to anywhere else,
              <span v-if="isMob"><br></span>
              and they support the entire generation.
            </p>
            <br>
          </div>
          <div class="page-6-content-text">
            <p>
              The residents overcame the suicide wave,
              <span v-if="isMob"><br></span>
              and help the children to move beyond the sorrow.
              <span v-if="isMob"><br></span>
              They support themselves and stand strong.
            </p>
          </div>
          <p><br></p>
          <p class="read-more-button-green" @click="sendOutlinkButtonGA('後重建')"><a href="./rebuild/" target="_blank">Read more</a></p>
        </div>
      </NormalPage>
      <NormalPage
        :PAGE_INDEX="5"
        :PAGE_AMOUNT="PAGE_AMOUNT"
        :currentPage="currentPage"
        :scrollDownArrowFlag="scrollDownArrowFlag"
      >
        <div class="page-5-background" slot="background">
          <!-- <img class="page-5-background-img page-5-background-img-animation-1"
            :src="require('./assets/images/page5/921_page_background_up1.jpg')"
            alt="921二十周年"
          >
          <img class="page-5-background-img page-5-background-img-animation-2"
            :src="require('./assets/images/page5/921_page_background_up2.jpg')"
            alt="921二十周年"
          >
          <img class="page-5-background-img page-5-background-img-animation-3"
            :src="require('./assets/images/page5/921_page_background_up3.jpg')"
            alt="921二十周年"
          >
          <img class="page-5-background-img page-5-background-img-animation-4"
            :src="require('./assets/images/page5/921_page_background_up4.jpg')"
            alt="921二十周年"
          >
          <img class="page-5-background-img page-5-background-img-animation-5"
            :src="require('./assets/images/page5/921_page_background_up5.jpg')"
            alt="921二十周年"
          >
          <img class="page-5-background-img page-5-background-img-animation-6"
            :src="require('./assets/images/page5/921_page_background_up6.jpg')"
            alt="921二十周年"
          >
          <img class="page-5-background-img page-5-background-img-animation-7"
            :src="require('./assets/images/page5/921_page_background_up7.jpg')"
            alt="921二十周年"
          > -->
        </div>
        <div class="page-5-content text-white" slot="content">
          <div class="page-5-content-text">
            <div :class="{
              'page-5-content-text-1': true,
              'page-5-content-animation-1': page5Config.contentFlag,
              }"
            >
              <p>But the help from the whole world entered the stricken area, </p>
              <p><br></p>
            </div>
            <div :class="{
              'page-5-content-text-2': true,
              'page-5-content-animation-2': page5Config.contentFlag,
              }"
            >
              <p>More than 600 thousand people worked on rescuing, cleaning, building.</p>
              <p>13 countries sent rescue teams to Taiwan.</p>
              <p>More than 1 billion USD were donated for financial support.</p>
              <p><br></p>
            </div>
            <div :class="{
              'page-5-content-text-3': true,
              'page-5-content-animation-3': page5Config.contentFlag,
              }"
            >
              <p>By looking forward,</p>
              <p>victims would not be victims forever.</p>
            </div>
            <p><br></p>
            <div :class="{
              'page-5-content-text-4': true,
              'page-5-content-animation-4': page5Config.contentFlag,
              }"
            >
              The house could fall.
              <span><br></span>
              As long as the “home” still stands, we must take care of it.
            </div>
          </div>
        </div>
      </NormalPage>
      <NormalPage
        :PAGE_INDEX="4"
        :PAGE_AMOUNT="PAGE_AMOUNT"
        :currentPage="currentPage"
        :scrollDownArrowFlag="scrollDownArrowFlag"
      >
        <div class="page-4-background" slot="background">
          <!-- 第五張動畫結束後就靜止 -->
          <img 
            :class="{
              'page-4-background-image': true,
              'page-4-background-animation-1': page4Config.bgFlag,
            }"
            :src="require(
              isMob ?
              './assets/images/page4/921_page_background_people1.jpg' :
              './assets/images/page4/web/921_page_background_people1_pc.jpg'
            )"
            height="100%"
            alt="921二十周年"
          >
          <img 
            :class="{
              'page-4-background-image': true,
              'page-4-background-animation-2': page4Config.bgFlag,
            }"
            :src="require(
              isMob ?
              './assets/images/page4/921_page_background_people2.jpg' :
              './assets/images/page4/web/921_page_background_people2_pc.jpg'
            )"
            height="100%"
            alt="921二十周年"
          >
          <img 
            :class="{
              'page-4-background-image': true,
              'page-4-background-animation-3': page4Config.bgFlag,
            }"
            :src="require(
              isMob ?
              './assets/images/page4/921_page_background_people3.jpg' :
              './assets/images/page4/web/921_page_background_people3_pc.jpg'
            )"
            height="100%"
            alt="921二十周年"
          >
          <img 
            :class="{
              'page-4-background-image': true,
              'page-4-background-animation-4': page4Config.bgFlag,
            }"
            :src="require(
              isMob ?
              './assets/images/page4/921_page_background_people4.jpg' :
              './assets/images/page4/web/921_page_background_people4_pc.jpg'
            )"
            height="100%"
            alt="921二十周年"
          >
          <img 
            :class="{
              'page-4-background-image': true,
              'page-4-background-animation-5': page4Config.bgFlag,
            }"
            :src="require(
              isMob ?
              './assets/images/page4/921_page_background_people5.jpg' :
              './assets/images/page4/web/921_page_background_people5_pc.jpg'
            )"
            height="100%"
            alt="921二十周年"
          >
        </div>
        <div class="page-4-content text-white" slot="content">
          <h3>Friends and family kept asking<br>“why don’t you want to leave the heartbreaking zones?”</h3>
          <p><br></p>
          <p class="read-more-button-green" @click="sendOutlinkButtonGA('人物')"><a href="./people/children/" target="_blank">Read more</a></p>
        </div>
      </NormalPage>
      <NormalPage
        :PAGE_INDEX="3"
        :PAGE_AMOUNT="PAGE_AMOUNT"
        :currentPage="currentPage"
        :scrollDownArrowFlag="scrollDownArrowFlag"
      >
        <div class="page-3-background" slot="background">
          <!-- <img
            :class="{
              'page-3-background-animation': page3Config.bgFlag
            }"
            :src="require(isMob ? 
              './assets/images/page3/921_page_background.jpg' :
              './assets/images/page3/web/921_page_background_pc.jpg'
            )"
            alt="921二十周年"
          > -->
        </div>
        <div class="page-3-content text-white" slot="content">
          <p>Facing the once familiar home hit by the quake,</p>
          <p>the victims were devastated,</p>
          <p>and speechless.</p>
          <br>
          <p>When the daybreak hit,</p>
          <p>our hearts were still in the dark,</p>
          <p>as tomorrow would never come.</p>
        </div>
      </NormalPage>
      <NormalPage
        :PAGE_INDEX="2"
        :PAGE_AMOUNT="PAGE_AMOUNT"
        :currentPage="currentPage"
        :scrollDownArrowFlag="scrollDownArrowFlag"
      >
        <div class="full-vidoe-wrapper" slot="background">
          <video
            ref="page2VideoRef"
            class="opening-video"
            :src="selectCoverVideoSrc"
            width="100%"
            webkit-playsinline
            playsinline
            muted
          ></video>
        </div>
      </NormalPage>
      <NormalPage
        :PAGE_INDEX="1"
        :PAGE_AMOUNT="PAGE_AMOUNT"
        :currentPage="currentPage"
        :scrollDownArrowFlag="scrollDownArrowFlag"
      >
        <div class="page-1-content text-white" slot="content">
          <div class="page-1-content-section">
            <p>That night</p>
            <br>
          </div>
          <div class="page-1-content-section">
            <div :class="{
              'page-1-text': true,
              'page-1-text-animation-1': page1Config.textLightFlag,
              }"
            >
              <h2>2415 lives</h2>
              <p>never wake up again.</p>
            </div>
            <div :class="{
              'page-1-text': true,
              'page-1-text-animation-2': page1Config.textLightFlag,
              }"
            >
              <h2>134 children</h2>
              <p>became parentless orphans.</p>
            </div>
            <div :class="{
              'page-1-text': true,
              'page-1-text-animation-3': page1Config.textLightFlag,
              }"
            >
              <h2>Over 100,000 buildings</h2>
              <p>collapsed after the quake.</p>
            </div>
            <div :class="{
              'page-1-text': true,
              'page-1-text-animation-4': page1Config.textLightFlag,
              }"
            >
              <h2>Thousands of people</h2>
              <p>fought for their lives in the rubbles.</p>
            </div>
          </div>
        </div>
      </NormalPage>
      <MainCover
        :PAGE_INDEX="0"
        :currentPage="currentPage"
        :scrollDownArrowFlag="scrollDownArrowFlag"
        :coverStep="coverStep"
      >
      </MainCover>
    </div>
    <div :id="'page' + PAGE_AMOUNT">
      <!-- anchor -->
    </div>
    <MemoryGallery
      :memoryEnterFlag="memoryEnterFlag"
    />
    <div class="general-components">
      <Relate preHref="https://udn.com/newmedia/921/"></Relate>
      <Comment href="https://udn.com/newmedia/921/"></Comment>
      <Logo></Logo>
      <Author
        :author="{
          producer: {
            title: 'Producer',
            member: ['Lin Hsiu-Tzu', 'Hung Hsin-Tzu', 'Tsai Pei-Jung', 'Hsieh Wen-Chun']
          },
          photographer: {
            title: 'Photographer',
            member: ['Lin Yong-Xuan', 'Yan Kai-Syu', 'Jheng Cing-Yuan', 'Huang Chung-Yu', 'UDN Data']
          },
          designer: {
            title: 'Designer',
            member: ['Chang Hsin-Tzu'],
          },
          engineer: {
            title: 'Engineer',
            member: ['Yang Juo-Yu'],
          },
          marketing: {
            title: 'Digital Marketing Specialist',
            member: ['Chen Yu-Syuan', 'Liu Shih-Chun'],
          },
          unit: {
            title: 'Production Unit',
            member: ['New Media Center', 'Visual Design Center'],
          },
        }"
        :org="'Organized by United Daily News Group'"
        :date="'2019.09.16'"
      />
      <Footer></Footer>
    </div>
    <GeneralWidget v-if="currentPage === PAGE_AMOUNT" :useMemory="false" :currentPage="currentPage"/>
    <VoiceButton :currentPage="currentPage"/>
  </div>
</template>

<script>
import Utils from 'udn-newmedia-utils';

import Hammer from 'hammerjs';
import _debounce from 'lodash.debounce';
import HeaderBar from '../../general_components/HeaderBar.vue';
import Comment from '../../general_components/Comment.vue';
import Relate from '../../general_components/Relate.vue';
import Footer from '../../general_components/Footer.vue';
import GeneralWidget from '../../general_components/GeneralWidget.vue';
import Author from './components/Author.vue';
import Logo from './components/Logo.vue';
import MainCover from './components/cover/MainCover.vue';
import NormalPage from './components/pages/NormalPage.vue';
import ProgressBar from './components/ProgressBar.vue';
import Map921 from './components/Map921.vue';
import MemoryGallery from './components/MemoryGallery.vue';
import VoiceButton from './components/VoiceButton.vue';

const VueScrollTo = require('vue-scrollto');

export default {
  name: 'app',
  components: {
    MainCover,
    Map921,
    MemoryGallery,
    NormalPage,
    ProgressBar,
    VoiceButton,
    HeaderBar,
    Comment,
    Logo,
    Author,
    Relate,
    Footer,
    GeneralWidget,
  },
  data() {
    return {
      currentPage: 0,
      PAGE_AMOUNT: 14, // 封面 + 內文 + 封底共用元件
      scrollDownArrowFlag: true,
      coverStep: 0,
      readMoreText: '閱讀故事',
      readMoreLink: '',
      page1Config: {
        textLightFlag: false,
        bgColor: '#000000',
      },
      page2Config: {
      },
      page3Config: {
        bgFlag: false,
      },
      page4Config: {
        bgFlag: false,
      },
      page5Config: {
        contentFlag: false,
      },
      page6Config: {
        bgColor: '#ffffff',
        bgFlag: false,
      },
      page7Config: {
        stepFlag_1: true,
        stepFlag_2: false,
        bgColor: '#ffffff',
        dynamicDigit_1: 250,
        dynamicDigit_2: 0,
      },
      page8Config: {
        bgColor: '#ffffff',
        mapFlag: false,
      },
      page9Config: {
        contentFlag: false,
        bgColor: 'null',
      },
      page10Config: {
        bgFlag: false,
      },
      page11Config: {
        bgFlag: false,
      },
      page12Config: {
      },
      page13Config: {
        contentFlag: false,
      },
      memoryEnterFlag: false,
    };
  },
  computed: {
    isMob() {
      return window.innerWidth < 769 ? true : false; 
    },
    selectCoverVideoSrc() {
      if (window.innerWidth < 768) {
        return 'https://p3.udn.com.tw/921/main/921_page_video_2.mp4';
      } else if (window.innerWidth >= 768 && window.innerWidth <= 1024) {
        return 'https://p3.udn.com.tw/921/main/ipad768x1024_4-3.mp4';
      } else {
        return 'https://p3.udn.com.tw/921/main/921_page_video_web_2.mp4';
      }
    },
    mainAppFixedFlag() {
      return this.currentPage < this.PAGE_AMOUNT ? true : false;
    },
  },
  watch: {
    currentPage: {
      handler(page) {
        this.sendProgressGA();
        switch (page) {
          case 0:
            break;

          case 1:
            this.page1Config.textLightFlag = true;
            break;

          case 2:
            // 播放完自動略過
            this.$refs.page2VideoRef.onended = () => {     
              this.updatePage('up');
            };
            this.$refs.page2VideoRef.currentTime = 0;
            this.$refs.page2VideoRef.play();   
            break;

          case 3:
            this.page3Config.bgFlag = true;
            break;

          case 4:
            this.page4Config.bgFlag = true;
            break;

          case 5:
            this.page5Config.contentFlag = true;
            break;

          case 6:
            this.page6Config.bgFlag = true;
            break;

          case 7:
            this.page7Config.dynamicDigit_1 = 250;
            this.page7Config.dynamicDigit_2 = 0;
            const digitTimer = setInterval(() => {
              if (this.page7Config.dynamicDigit_1 < 500) {
                this.page7Config.dynamicDigit_1++;
              }
              if (this.page7Config.dynamicDigit_2 < 293) {
                this.page7Config.dynamicDigit_2++;
              }
              if (this.page7Config.dynamicDigit_1 >= 500 && this.page7Config.dynamicDigit_2 >= 293) {
                clearTimer();
              }
            }, 5);
            function clearTimer() {
              clearInterval(digitTimer);
            }
            break;

          case 8:
            this.page8Config.mapFlag = true;
            break;

          case 9:
            this.page9Config.contentFlag = true;
            break;

          case 10:
            this.page10Config.bgFlag = true;
            break;

          case 11:
            this.page11Config.bgFlag = true;
            break;

          case 12:
            break;

          case 13:
            this.page13Config.contentFlag = true;
            // 播放完自動略過
            // this.$refs.page13VideoRef.onended = () => {
            //   this.page13Config.contentFlag = false;
            //   this.updatePage('up');
            // };
            this.$refs.page13VideoRef.currentTime = 0;
            this.$refs.page13VideoRef.play();   
            break;

          case 14:
            this.memoryEnterFlag = true;
            break;

          default:
            break;
        }
      },
      deep: true
    }
  },
  methods: {
    handleSwpiePage(direction) {
      switch (this.currentPage) {
        case 0:
          // 只要開始震動就可以下一頁，不用等震動結束
          if (direction === 'up') {
            switch (this.coverStep) {
              case 0:
                this.coverStep = 1;
                setTimeout(() => {
                  if (this.coverStep === 1) {
                    this.coverStep = 2;
                  }
                }, 5000);
                break;
              case 1:
                this.coverStep = 2;
                break;
              case 2:
                this.updatePage(direction);
                break;
            }
          } else {
            switch (this.coverStep) {
              case 0:
                break;
              case 1:
                break;
              case 2:
                this.coverStep = 0;
                setTimeout(() => {
                  if (this.coverStep === 0) {
                    this.coverStep = 1;
                  }
                }, 5000);
                setTimeout(() => {
                  if (this.coverStep === 1) {
                    this.coverStep = 2;
                  }
                }, 10000);
                break;
            }
          }
          break;
        case 1:
          this.handleScrollDownArrow();
          this.updatePage(direction);
          setTimeout(() => {
            if (this.currentPage !== 1)
              this.page1Config.textLightFlag = false;
          }, 1200);
          break;
        case 2:
          this.handleScrollDownArrow();
          this.updatePage(direction);
          // 影片暫停
          this.$refs.page2VideoRef.pause();
          break;
        case 3:
          this.handleScrollDownArrow();
          this.updatePage(direction);
          setTimeout(() => {
            if (this.currentPage !== 3)
              this.page3Config.bgFlag = false;
          }, 1200);
          break;
        case 4:
          this.handleScrollDownArrow();
          this.updatePage(direction);
          setTimeout(() => {
            if (this.currentPage !== 4)
              this.page4Config.bgFlag = false;
          }, 1200);
          break;
        case 5:
          this.handleScrollDownArrow();
          this.updatePage(direction);
          setTimeout(() => {
            if (this.currentPage !== 5)
              this.page5Config.contentFlag = false;
          }, 1200);
          break;
        case 6:
          this.handleScrollDownArrow();
          this.updatePage(direction);
          setTimeout(() => {
            if (this.currentPage !== 6)
              this.page6Config.bgFlag = false;
          }, 1200);
          break;
        case 7:
          this.handleScrollDownArrow();
          this.updatePage(direction);
          break;
        case 8:
          this.handleScrollDownArrow();
          this.updatePage(direction);
          setTimeout(() => {
            if (this.currentPage !== 8)
              this.page8Config.mapFlag = false;
          }, 1200);
          break;
        case 9:
          this.handleScrollDownArrow();
          this.updatePage(direction);
          setTimeout(() => {
            if (this.currentPage !== 9)
              this.page9Config.contentFlag = false;
          }, 1200);
          break;
        case 10:
          this.handleScrollDownArrow();
          this.updatePage(direction);
          setTimeout(() => {
            if (this.currentPage !== 10)
              this.page10Config.bgFlag = false;
          }, 1200);
          break;
        case 11:
          this.handleScrollDownArrow();
          this.updatePage(direction);
          setTimeout(() => {
            if (this.currentPage !== 11)
              this.page11Config.bgFlag = false;
          }, 1200);
          break;
        case 12:
          this.handleScrollDownArrow();
          this.updatePage(direction);
          break;
        case 13:
          this.handleScrollDownArrow();
          setTimeout(() => {
            this.updatePage(direction);
          }, 50);
          // 影片暫停
          this.$refs.page13VideoRef.pause();
          setTimeout(() => {
            if (this.currentPage !== 13)
              this.page13Config.contentFlag = false;
          }, 1200);

          break;
        case 14:
          // this.handleScrollDownArrow();
          this.updatePage(direction);
          setTimeout(() => {
            if (this.currentPage !== 14)
              this.memoryEnterFlag = false;
          }, 1200);
          break;
        default:
          break;
      }
    },
    handleScroll: _debounce(function(e) {
      // 閱讀內文
      if (this.currentPage < this.PAGE_AMOUNT) {
        if (e.deltaY > 0) {
          this.handleSwpiePage('up');
        }
        if (e.deltaY < 0) {
          this.handleSwpiePage('down');
        }
      }
    }, 200, {'leading': true, 'trailing': false, 'maxWait': 1000}),
    handleControllerScroll: _debounce(function() {
      if (this.currentPage >= this.PAGE_AMOUNT) {
        if (window.pageYOffset < window.innerHeight * 0.1) {
          VueScrollTo.scrollTo('#app');
          this.handleSwpiePage('down');
        }
      }
    }, 100),
    updatePage(direction) {
      const vm = this;
      function updateCurrentPage() {
        return new Promise(function(resolve) {
          vm.currentPage = direction === 'up' ? ++vm.currentPage : --vm.currentPage;
          if (vm.currentPage < 0) {
            vm.currentPage = 0;
          }
          if (vm.currentPage > vm.PAGE_AMOUNT) {
            vm.currentPage = vm.PAGE_AMOUNT;
          }
          resolve(1);
        });
      }
      function scrollToPage() {
        if (vm.currentPage === 14) VueScrollTo.scrollTo('#page' + vm.currentPage);
        return 2;
      }

      updateCurrentPage()
        .then(scrollToPage);

      // console.log('Current page: ' + this.currentPage, direction);
    },
    handleScrollDownArrow() {
      this.scrollDownArrowFlag = false;
      setTimeout(()=>{
        this.scrollDownArrowFlag = true;
      }, 3000)
    },
    sendProgressGA() {
      window.ga("newmedia.send", {
        "hitType": "event",
        "eventCategory": "Read",
        "eventAction": "page",
        "eventLabel": "[" + Utils.detectPlatform() + "] [" + document.querySelector('title').innerHTML + "] [第" + this.currentPage + "頁]"
      });
    },
    sendOutlinkButtonGA(target) {
      window.ga("newmedia.send", {
        "hitType": "event",
        "eventCategory": "button",
        "eventAction": "click",
        "eventLabel": "[" + Utils.detectPlatform() + "] [" + document.querySelector('title').innerHTML + "] [閱讀故事-" + target + "]"
      });
    },
  },
  mounted() {
    const MainAppController = document.getElementById('main-app');
    if (window.innerWidth >= 768) {
      MainAppController.addEventListener('wheel', e => { this.handleScroll(e); }, true);
    }

    window.addEventListener('scroll', this.handleControllerScroll);
    const hammerController = new Hammer(MainAppController);
    hammerController.get('swipe').set({
      direction: Hammer.DIRECTION_VERTICAL,
      threshold: 5,
    });
    hammerController.on("swipeup", () => {
      this.handleSwpiePage('up');
    });
    hammerController.on("swipedown", () => {
      this.handleSwpiePage('down');
    });

    // 首頁先send一次GA
    this.sendProgressGA();
    // 進入5秒後開始震動
    setTimeout(() => {
      if (this.coverStep === 0) {
        this.coverStep = 1;
      }
    }, 5000);
    setTimeout(() => {
      if (this.coverStep === 1) {
        this.coverStep = 2;
      }
    }, 10000);

    // rec.udn.com追蹤碼
    window.onload = () => {
      document.getElementsByTagName('iframe')[0].style.top = 0;
    };
  },
  destroyed() {
    if (window.innerWidth >= 768) {
      const MainAppController = document.getElementById('main-app');
      MainAppController.removeEventListener('scroll', this.handleScroll);
    }
    window.removeEventListener('scroll', this.handleControllerScroll);
  },
};
</script>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css?family=Lato&display=swap');
  // @import url('https://fonts.googleapis.com/css?family=Lato|Tinos&display=swap');
  @import url('https://fonts.googleapis.com/css?family=Lato|Lora&display=swap');

  body::-webkit-scrollbar {
    display: none;
  }
  body {
    overflow: -moz-scrollbars-none;
    -ms-overflow-style: none;
  }
  @font-face {
    font-family: Tinos;
    // font-family: Ming;
    src: url('assets/fonts/ARMingB5Medium.otf');
  }
  @font-face {
    font-family: digital;
    src: url('assets/fonts/digital-7.ttf');
  }
  #app {
    position: relative;
    p {
      font-family: 'Lato', sans-serif;
      margin: 0;
      @media only screen and (max-width: 375px) {
        font-size: 15px;
        line-height: 1.5;
        // font-size: 1rem;
      }
    }
    .main-app {
      position: relative;
      z-index: 10;
      -ms-overflow-style: none;
      overflow: -moz-scrollbars-none;
      overflow-y: auto;
      width: 100%;
      background-color: #000000;

      // page-1
      .page-1-content {
        position: relative;
        width: 100%;
        margin-top: 8vh;
        padding: 0 20px 0 20px;
        @media only screen and (min-width: 768px) {
          display: flex;
          justify-content: center;
        }
        p {
          margin-bottom: 20px;
        }

        .page-1-content-section {
          @media only screen and (min-width: 768px) and (max-width: 1024px) {
            margin: 30px;
          }
          @media only screen and (min-width: 1025px) {
            margin: 50px;
          }
          .page-1-text {
            text-align: left;
            opacity: 0.3;
          }
          .page-1-text-animation-1 {
            animation-name: lightAnimation;
            animation-duration: 1.5s;
            animation-delay: 1s;
            animation-timing-function: ease-in-out;
            animation-fill-mode: forwards;
          }
          .page-1-text-animation-2 {
            animation-name: lightAnimation;
            animation-duration: 1.5s;
            animation-delay: 2s;
            animation-timing-function: ease-in-out;
            animation-fill-mode: forwards;
          }
          .page-1-text-animation-3 {
            animation-name: lightAnimation;
            animation-duration: 1.5s;
            animation-delay: 3s;
            animation-timing-function: ease-in-out;
            animation-fill-mode: forwards;
          }
          .page-1-text-animation-4 {
            animation-name: lightAnimation;
            animation-duration: 1.5s;
            animation-delay: 4s;
            animation-timing-function: ease-in-out;
            animation-fill-mode: forwards;
          }
          @keyframes lightAnimation {
            0% {
              opacity: 0.3;
            }
            100% {
              opacity: 1;
            }
          }
        }
      }

      // page-3
      .page-3-background {
        position: relative;
        width: 100%;
        height: 100%;
        background-image: url('./assets/images/page3/921_page_background.jpg');
        background-size: cover;
        background-position: center bottom;
        @media only screen and (min-width: 1024px) {
          background-image: url('./assets/images/page3/web/921_page_background_pc.jpg');
        }
        // position: absolute;
        // top: 0;
        // left: 0;
        // width: 100%;
        // height: 100%;
        // transition: opacity .8s ease-in-out;
        // @media only screen and (min-width: 1024px) and (max-width: 1280px) {
        //   top: -50%;
        //   left: 10%;
        // }
        // @media only screen and (min-width: 1281px) {
        //   top: -80%;
        //   left: 15%;
        // }
        .page-3-background-animation {
          width: auto;
          height: 100%;
          transform: translateX(-30%);
          @media only screen and (min-width: 1024px) and (max-width: 1280px) {
            height: 150%;
          }
          @media only screen and (min-width: 1281px) {
            height: 185%;
          }
        //   animation-name: slideAnimation;
        //   animation-duration: 5s;
        //   animation-timing-function: ease-in-out;
        //   animation-fill-mode: forwards;
        // }
        // @keyframes slideAnimation {
        //   0% {
        //     transform: translateX(-15%);
        //   }
        //   100% {
        //     transform: translateX(-30%);
        //   }
        }
      }
      .page-3-content {
        position: relative;
        width: 100%;
        margin-top: 10vh;
        text-align: left;
        padding-left: 10%;
      }

      // page-4
      .page-4-background {
        position: relative;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        .page-4-background-image {
          position: absolute;
          top: 0;
          left: -30%;
          width: auto;
          height: 100%;
          @media only screen and (min-width: 768px) and (max-width: 1023px) {
            height: 120%;
            left: -25%;
          }
          @media only screen and (min-width: 1024px) and (max-width: 1366px) {
            height: 135%;
            top: -15%;
            left: -35%;
          }
          @media only screen and (min-width: 1367px) {
            height: 135%;
            top: -15%;
            left: 0%;
          }
        }
        .page-4-background-animation-1 {
          opacity: 0;
          animation-name: scaleAnimation-1;
          animation-duration: 3s;
          animation-timing-function: linear;
        }
        .page-4-background-animation-2 {
          opacity: 0;
          animation-name: scaleAnimation-2;
          animation-duration: 3s;
          animation-delay: 2s;
          animation-timing-function: linear;
        }
        .page-4-background-animation-3 {
          opacity: 0;
          animation-name: scaleAnimation-1;
          animation-duration: 3s;
          animation-delay: 4s;
          animation-timing-function: linear;
        }
        .page-4-background-animation-4 {
          opacity: 0;
          animation-name: scaleAnimation-1;
          animation-duration: 3s;
          animation-delay: 6s;
          animation-timing-function: linear;
        }
        .page-4-background-animation-5 {
          opacity: 0;
          animation-name: scaleAnimation-1;
          animation-duration: 3s;
          animation-delay: 8s;
          animation-timing-function: linear;
          animation-fill-mode: forwards;
        }
        @keyframes scaleAnimation-1 {
          0% {
            opacity: 0;
            transform: scale(1.2);
          }
          30% {
            opacity: 1;
          }
          100% {
            opacity: 1;
            transform: scale(1);
          }
        }
        @keyframes scaleAnimation-2 {
          0% {
            opacity: 0;
            transform: translate(60px, -60px) scale(1.2);
          }
          30% {
            opacity: 1;
          }
          100% {
            opacity: 1;
            transform: translate(0, 0) scale(1);
          }
        }
      }
      .page-4-content {
        position: relative;
        width: 100%;
        margin-top: 48vh;
        // font-family: 'Tinos', sans-serif;
        font-family: 'Lora', sans-serif;
        // font-family: Ming;
        text-align: left;
        padding-left: 10%;
      }

      // page-5
      .page-5-background {
        .page-5-background-img {
          position: absolute;
          opacity: 0.3;
        }
        .page-5-background-img-animation-1 {
          top: 100%;
          right: 5%;
          width: 40%;
          animation-name: flyAnimation;
          animation-duration: 20s;
          animation-iteration-count: infinite;
          animation-timing-function: linear;
          @media only screen and (min-width: 769px) {
            width: 20%;
            right: 10%;
          }
        }
        .page-5-background-img-animation-2 {
          top: 110%;
          left: 20%;
          width: 50%;
          animation-name: flyAnimation;
          animation-duration: 21s;
          animation-delay: 2s;
          animation-iteration-count: infinite;
          animation-timing-function: linear;
          @media only screen and (min-width: 769px) {
            width: 25%;
            left: 35%;
          }
        }
        .page-5-background-img-animation-3 {
          top: 120%;
          left: 0%;
          width: 40%;
          animation-name: flyAnimation;
          animation-duration: 22s;
          animation-delay: 4s;
          animation-iteration-count: infinite;
          animation-timing-function: linear;
          @media only screen and (min-width: 769px) {
            width: 20%;
            left: 10%;
          }
        }
        .page-5-background-img-animation-4 {
          top: 130%;
          right: 5%;
          width: 70%;
          animation-name: flyAnimation;
          animation-duration: 23s;
          animation-delay: 6s;
          animation-iteration-count: infinite;
          animation-timing-function: linear;
          @media only screen and (min-width: 769px) {
            width: 35%;
            right: 10%;
          }
        }
        .page-5-background-img-animation-5 {
          top: 140%;
          left: 0;
          width: 30%;
          animation-name: flyAnimation;
          animation-duration: 20s;
          animation-delay: 8s;
          animation-iteration-count: infinite;
          animation-timing-function: linear;
          @media only screen and (min-width: 769px) {
            width: 15%;
            left: 18%;
          }
        }
        .page-5-background-img-animation-6 {
          top: 150%;
          right: 0;
          width: 60%;
          animation-name: flyAnimation;
          animation-duration: 21;
          animation-delay: 10s;
          animation-iteration-count: infinite;
          animation-timing-function: linear;
          @media only screen and (min-width: 769px) {
            width: 30%;
            right: 25%;
          }
        }
        .page-5-background-img-animation-7 {
          top: 160%;
          left: 20%;
          width: 40%;
          animation-name: flyAnimation;
          animation-duration: 22s;
          animation-delay: 12s;
          animation-iteration-count: infinite;
          animation-timing-function: linear;
          @media only screen and (min-width: 769px) {
            width: 20%;
            left: 28%;
          }
        }
        @keyframes flyAnimation {
          0% {
            transform: translateY(0);
          }
          100% {
            transform: translateY(-200vh);
          }
        }
      }
      .page-5-content {
        position: relative;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: left;
        .page-5-content-text {
          position: relative;
          display: inline-block;
          text-align: left;
          padding-left: 10%;
          @media screen and (min-width: 768px) {
            padding-left: 0%;
          }
          .page-5-content-text-1 {
            position: relative;
            display: inline-block;
            text-align: left;
            opacity: 0.3;
            @media screen and (min-width: 768px) {
              display: flex;
            }
          }
          .page-5-content-text-2 {
            position: relative;
            display: inline-block;
            text-align: left;
            opacity: 0.3;
          }
          .page-5-content-text-3 {
            position: relative;
            display: inline-block;
            opacity: 0.3;
            @media screen and (min-width: 768px) {
              display: flex;
            }
          }
          .page-5-content-text-4 {
            position: relative;
            display: inline-block;
            text-align: left;
            font-family: 'Lora', sans-serif;
            // font-family: 'Tinos', sans-serif;
            // font-family: Ming;
            opacity: 0.3;
            line-height: 1.3;
            font-weight: normal;
            font-size: 1.6rem;
            color: #ffffff;
            @media screen and (min-width: 768px){
              display: flex;
            }
          }
        }
        .page-5-content-animation-1 {
          animation-name: lightAnimation;
          animation-duration: 1.5s;
          animation-delay: 1s;
          animation-timing-function: ease-in-out;
          animation-fill-mode: forwards;
        }
        .page-5-content-animation-2 {
          animation-name: lightAnimation;
          animation-duration: 1.5s;
          animation-delay: 2s;
          animation-timing-function: ease-in-out;
          animation-fill-mode: forwards;
        }
        .page-5-content-animation-3 {
          animation-name: lightAnimation;
          animation-duration: 1.5s;
          animation-delay: 3s;
          animation-timing-function: ease-in-out;
          animation-fill-mode: forwards;
        }
        .page-5-content-animation-4 {
          animation-name: lightAnimation-green;
          animation-duration: 1.5s;
          animation-delay: 4s;
          animation-timing-function: ease-in-out;
          animation-fill-mode: forwards;
        }
        @keyframes lightAnimation {
          0% {
            opacity: 0.3;
          }
          100% {
            opacity: 1;
          }
        }
        @keyframes lightAnimation-green {
          0% {
            opacity: 0.3;
          }
          100% {
            opacity: 1;
            color: #57b09f;
          }
        }
      }

      // page-6
      .page-6-background {
        position: relative;
        width: 100%;
        height: 100%;
        .page-6-background-img {
          position: absolute;
          bottom: 5%;
          left: 0;
          // height: 40%;
          width: 100%;
        }
        .page-6-background-img-animation-1 {
          // transform: translateX(-150vw);
          // animation: flyAnimation-1 25s linear infinite;
          opacity: 0;
          animation: flyAnimation 5s ease-in-out;
          @media only screen and (min-width: 768px) and (max-width: 1023px) {
            transform: translateX(0);
            height: auto;
            width: 80%;
            left: 10%;
            bottom: 15%;
            opacity: 0;
            animation: flyAnimation-web 1s ease-in-out forwards;
          }
          @media only screen and (min-width: 1024px) {
            transform: translateX(0);
            height: auto;
            width: 58%;
            left: 28%;
            bottom: -8%;
            opacity: 0;
            animation: flyAnimation-web 1s ease-in-out forwards;
          }
        }
        .page-6-background-img-animation-2 {
          // transform: translateX(-150vw);
          // animation: flyAnimation-2 25s 5s linear infinite;
          opacity: 0;
          animation: flyAnimation 5s 4s ease-in-out;
          @media only screen and (min-width: 768px) and (max-width: 1023px) {
            transform: translateX(0);
            height: auto;
            width: 60%;
            left: 50%;
            bottom: 50%;
            opacity: 0;
            animation: flyAnimation-web 1s 1.5s ease-in-out forwards;
          }
          @media only screen and (min-width: 1024px) {
            transform: translateX(0);
            height: auto;
            width: 42%;
            left: 64%;
            bottom: 53%;
            opacity: 0;
            animation: flyAnimation-web 1s 1.5s ease-in-out forwards;
          }
        }
        .page-6-background-img-animation-3 {
          // transform: translateX(-150vw);
          // animation: flyAnimation-3 25s 10s linear infinite;
          opacity: 0;
          animation: flyAnimation 5s 8s ease-in-out;
          @media only screen and (min-width: 768px) and (max-width: 1023px) {
            transform: translateX(0);
            height: auto;
            width: 60%;
            left: 20%;
            top: -15%;
            bottom: initial;
            opacity: 0;
            animation: flyAnimation-web 1s 3s ease-in-out forwards;

          }
          @media only screen and (min-width: 1024px) {
            transform: translateX(0);
            height: auto;
            width: 23%;
            left: 12%;
            top: 3%;
            bottom: initial;
            opacity: 0;
            animation: flyAnimation-web 1s 3s ease-in-out forwards;
          }
        }
        .page-6-background-img-animation-4 {
          // transform: translateX(-150vw);
          // animation: flyAnimation-1 25s 15s linear infinite;
          opacity: 0;
          animation: flyAnimation 5s 12s ease-in-out;
          @media only screen and (min-width: 768px) and (max-width: 1023px) {
            display: none;
            animation-name: none;
          }
          @media only screen and (min-width: 1024px) {
            display: none;
            animation-name: none;
          }
        }
        .page-6-background-img-animation-5 {
          // transform: translateX(-150vw);
          // animation: flyAnimation-2 25s 20s linear infinite;
          opacity: 0;
          animation: flyAnimation-end 5s 16s ease-in-out forwards;
          @media only screen and (min-width: 768px) and (max-width: 1023px) {
            display: none;
            animation-name: none;
          }
          @media only screen and (min-width: 1024px) {
            display: none;
            animation-name: none;
          }
        }
        @keyframes flyAnimation {
          0% {
            opacity: 0;
          }
          50% {
            opacity: 1;
          }
          100% {
            opacity: 0;
          }
        }
        @keyframes flyAnimation-end {
          0% {
            opacity: 0;
          }
          50% {
            opacity: 1;
          }
          100% {
            opacity: 1;
          }
        }
        @keyframes flyAnimation-web {
          0% {
            opacity: 0;
          }
          100% {
            opacity: 1;
          }
        }
      }
      .page-6-content {
        position: relative;
        width: 100%;
        margin-top: 10vh;
        text-align: left;
        padding-left: 10%;
        @media only screen and (min-width: 768px) and (max-width: 1024px) {
          margin-top: 25%;
        }
        @media only screen and (min-width: 1025px) {
          text-align: left;
          margin-top: 21%;
          padding-left: 15%;
        }
        .page-6-content-text {
          @media only screen and (min-width: 768px) {
            padding-right: 20%;
          }
        }
      }

      // page-7
      .page-7-background {
        position: relative;
        width: 100%;
        height: 100%;
        transition: opacity .333s ease-in-out;
        .page-7-background {
          position: absolute;
          top: 10%;
          right: 0;
          width: 50vw;
          height: 50vw;
          display: flex;
          justify-content: center;
          align-items: center;
          // animation: circle 8s linear infinite;
          // transform-origin: 25% 50%;
          .page-7-background-image {
            position: relative;
            width: 250%;
            @media only screen and (min-width: 768px) and (max-width: 1024px) {
              position: absolute;
              top: -50%;
              left: -100%;
              width: 150%;
            }
            @media only screen and (min-width: 1025px) and (max-width: 1280px) {
              position: absolute;
              top: -30%;
              left: -100%;
              width: 100%;
              animation: inner-circle 1.5s linear infinite;
            }
            @media only screen and (min-width: 1281px) {
              position: absolute;
              top: -30%;
              left: -100%;
              width: 80%;
              animation: inner-circle 1.5s linear infinite;
            }
          }
          .page-7-background-image-web-1 {
            position: absolute;
            display: none;
            @media only screen and (min-width: 768px) and (max-width: 1024px) {
              display: block;
              top: 70%;
              left: 50%;
              width: 50%;
            }
            @media only screen and (min-width: 1025px) and (max-width: 1280px) {
              display: block;
              top: 30%;
              left: 30%;
              width: 50%;
            }
            @media only screen and (min-width: 1281px) {
              display: block;
              top: 15%;
              left: 30%;
              width: 50%;
            }
          }
          .page-7-background-image-web-2 {
            position: absolute;
            display: none;
            @media only screen and (min-width: 768px) and (max-width: 1024px) {
              display: block;
              top: 150%;
              left: -80%;
              width: 50%;
            }
            @media only screen and (min-width: 1025px) and (max-width: 1280px) {
              display: block;
              top: 90%;
              left: -50%;
              width: 50%;
            }
            @media only screen and (min-width: 1281px) {
              display: block;
              top: 60%;
              left: -50%;
              width: 30%;
            }
          }
          // @keyframes circle {
          //   from { transform:rotate(0deg); }
          //   to { transform:rotate(360deg); }
          // }
          @keyframes inner-circle {
            0% { transform: rotate(0deg); }
            25% { transform: rotate(90deg); }
            50% { transform: rotate(180deg); }
            75% { transform: rotate(270deg); }
            100% { transform: rotate(360deg); }
          }
        }
        .page-7-background-animation {
          @media only screen and (max-width: 320px) {
            animation: flyAndFadeAnimation-1 .666s ease-in-out forwards;
          }
          @media only screen and (min-width: 321px) and (max-width: 375px) {
            animation: flyAndFadeAnimation-1 .666s ease-in-out forwards;
          }
          @media only screen and (min-width: 376px) and (max-width: 411px) {
            animation: flyAndFadeAnimation-2 .666s ease-in-out forwards;
          }
          @media only screen and (min-width: 412px) and (max-width: 768px) {
            animation: flyAndFadeAnimation-3 .666s ease-in-out forwards;
          }
          @media only screen and (min-width: 769px) and (max-width: 1024px) {
            animation: flyAndFadeAnimation-3 .666s ease-in-out forwards;
          }
          @media only screen and (min-width: 1025px) and (max-width: 1280px) {
            animation: flyAndFadeAnimation-4 .666s ease-in-out forwards;
          }
          @media only screen and (min-width: 1281px) {
            animation: flyAndFadeAnimation-5 .666s ease-in-out forwards;
          }
        }
        @keyframes flyAndFadeAnimation-1 {
          0% {
            opacity: 1;
          }
          100% {
            opacity: 0;
            transform: translate(-50%, 200%) scale(0);
          }
        }
        @keyframes flyAndFadeAnimation-2 {
          0% {
            opacity: 1;
          }
          100% {
            opacity: 0;
            transform: translate(-50%, 160%) scale(0);
          }
        }
        @keyframes flyAndFadeAnimation-3 {
          0% {
            opacity: 1;
          }
          100% {
            opacity: 0;
            transform: translate(-10%, 40%) scale(0);
          }
        }
        @keyframes flyAndFadeAnimation-4 {
          0% {
            opacity: 1;
          }
          100% {
            opacity: 0;
            transform: translate(0%, 10%) scale(0);
          }
        }        
        @keyframes flyAndFadeAnimation-5 {
          0% {
            opacity: 1;
          }
          100% {
            opacity: 0;
            transform: translate(-30%, -10%) scale(0);
          }
        }
      }
      .page-7-content {
        position: relative;
        width: 100%;
        height: 100vh;
        .page-7-content-text-1 {
          position: relative;
          width: 100%;
          height: 35%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;
          padding: 0 20px 0 50%;
          text-align: left;
          @media only screen and (min-width: 768px) and (max-width: 1024px) {
            padding: 0 50% 0 30%;
          }
          @media only screen and (min-width: 1025px) {
            height: 30%;
            padding: 0 50% 0 15%;
          }
        }
        .page-7-content-text-2 {
          position: relative;
          width: 100%;
          height: 65%;
          padding: 0 10px;
          transform: translateY(-50px);
          @media only screen and (min-width: 768px) and (max-width: 1024px) {
            display: flex;
            justify-content: center;
            padding-top: 8%;
          }
          @media only screen and (min-width: 1025px) {
            display: flex;
            justify-content: flex-end;
            padding: 0 10%;
          }
          .dynamic-text-wrapper {
            position: relative;
            width: 100%;
            padding: 10px;
            margin-bottom: 20px;
            text-align: left;
            @media only screen and (min-width: 768px) and (max-width: 1024px) {
              width: 35%;
              padding: 20px;
            }
            @media only screen and (min-width: 1025px) {
              width: 35%;
              padding: 30px;
              margin-top: 6%;
              margin-right: 60px;
            }
            .dynamic-text {
              font-size: 40px;
              color: #57b09f;
              line-height: 0.8;
              margin-bottom: 10px;
            }
            .dynamic-text-sub {
              color: #57b09f;
              margin-bottom: 10px;
            }
          }
        }
      }

      // page-8
      .page-8-background {
        position: relative;
        width: 100%;
        height: 100%;
        .page-8-background-wrapper {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          display: flex;
          justify-content: center;
          transition: opacity .333s ease-in-out;
          @media only screen and (max-width: 320px) {
            top: 15%;
          }
          @media only screen and (min-width: 768px) and (max-width: 1280px) {
            height: 100%;
            display: flex;
            justify-content: flex-end;
            align-items: center;
          }
          @media only screen and (min-width: 1281px) {
            height: 100%;
            display: flex;
            justify-content: flex-end;
            align-items: center;
          }
          .map-wrapper {
            position: relative;
            width: 100%;
            height: 100%;
            @media only screen and (max-width: 320px) {
              transform: translate(-5%, 0%) scale(0.8);
            }
            @media only screen and (min-width: 321px) and (max-width: 767px) {
              transform: translate(4%, 23%) scale(1);
            }
            @media only screen and (min-width: 768px) and (max-width: 1023px) {
              transform: translate(43%, 30%) scale(1.3);
              padding-right: 10%;
            }
            @media only screen and (min-width: 1024px) and (max-width: 1279px) {
              transform: translate(65%, 50%) scale(1.8);
              padding-right: 10%;
            }
            @media only screen and (min-width: 1280px) and (max-width: 1366px) {
              transform: translate(70%, 30%) scale(1.6);
              padding-right: 10%;
            }
            @media only screen and (min-width: 1367px) {
              transform: translate(70%, 25%) scale(1.5);
              padding-right: 20%;
            }
          }
        }
      }
      .page-8-content {
        position: relative;
        width: 100%;
        height: 100vh;
        text-align: left;
        .page-8-content-text-1 {
          position: absolute;
          top: 10vh;
          left: 0;
          width: 100%;
          padding: 0 20px;
          @media only screen and (min-width: 768px) and (max-width: 1024px) {
            margin: 10% 0 0 10%;
          }
          @media only screen and (min-width: 1025px) {
            top: 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
            margin-left: 4%;
            height: 100%;
          }
        }
        .source-text-wrapper {
          position: absolute;
          bottom: 17.5vh;
          left: 5%;
          font-size: 12px;
          line-height: 1.5;
          color: #b4b1b1;
        }
      }

      // page-9
      .page-9-background {
        position: relative;
        width: 100%;
        height: 100vh;
        background-size: auto;
        background-position: 65% 0;
        .black-filter {
          position: relative;
          width: 100vw;
          height: 100vh;
          background-color: rgba(#000000, 0.8);
        }
      }
      .page-9-content {
        position: relative;
        width: 100%;
        height: 100%;
        padding-top: 8vh;
        margin: 0 12px;
        text-align: left;
        @media only screen and (min-width: 768px) and (max-width: 1024px) {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-start;
          padding: 20% 25%;
        }
        @media only screen and (min-width: 1025px) and (max-width: 1366px) {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-start;
          padding: 30vh 10% 0 45%;
        }
        @media only screen and (min-width: 1367px) {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-start;
          padding: 30vh 10% 0 55%;
        }
        .read-more-button-green {
          padding: 0;
          margin-left: 12px;
        }
        h4 {
          width: 100%;
          padding: 0 12px;
          font-family: 'Lora', sans-serif;
          // font-family: Tinos;
          // font-family: Ming;
        }
        .dynamic-bg-text-wrapper {
          position: relative;
          width: 100%;
          margin: 0 0 15px 12px;
          .dynamic-bg-text {
            position: relative;
            display: inline-block;
            .text-highlight {
              position: absolute;
              top: 0;
              left: 0;
              height: 100%;
              background-color: #c3dddd;
            }
            .text-highlight-animation {
              animation: highlightAnimation 3s ease-in-out forwards;
            }
            @keyframes highlightAnimation {
              from {
                width: 0;
              }
              to {
                width: 100%;
              }
            }
            .text {
              position: relative;
            }
          }
        }
        .page-9-content-img-wrapper {
          position: absolute;
          top: 52%;
          left: -25%;
          width: 110%;
          transform: rotate(12deg) translate(-500px, 500px);
          @media only screen and (max-width: 320px) {
            top: 60%;
          }
          @media only screen and (min-width: 768px) and (max-width: 1024px) {
            width: 90%;
            left: -10%;
          }
          @media only screen and (min-width: 1025px) and (max-width: 1366px) {
            width: 66%;
            top: 30%;
            left: -32%;
          }
          @media only screen and (min-width: 1367px) {
            width: 58%;
            top: 20%;
            left: -18%;
          }
        }
        .content-image-animation {
          animation: contentImageAnimation 1s ease-in-out forwards;
          @media only screen and (min-width: 1025px) {
            animation: contentImageAnimation-web 1s ease-in-out forwards;
          }
          @keyframes contentImageAnimation {
            to {
              transform: rotate(15deg) translate(0, 0);
            }
          }
          @keyframes contentImageAnimation-web {
            to {
              transform: rotate(37deg) translate(0, 0);
            }
          }
        }
      }

      // page-10
      .page-10-background {
        position: relative;
        width: 100%;
        height: 100%;
        .page-10-background-image {
          height: 100%;
          @media only screen and (min-width: 768px) and (max-width: 1023px) {
            height: 120%;
          }
          @media only screen and (min-width: 1024px) and (max-width: 1279px) {
            position: absolute;
            height: 195%;
            top: -50%;
            left: 0;
          }
          @media only screen and (min-width: 1280px) and (max-width: 1366px) {
            position: absolute;
            top: -60%;
            left: 0;
            height: 200%;
          }
          @media only screen and (min-width: 1367px) {
            position: absolute;
            top: -120%;
            left: 0;
            height: 300%;
          }
        }
        .page-10-background-animation {
          animation: scaleAnimation 10s ease-in-out forwards;
        }
        @keyframes scaleAnimation {
          from {
            transform: scale(1.2);
          }
          to {
            transform: scale(1);
          }
        }
      }
      .page-10-content {
        position: relative;
        width: 100%;
        margin-top: 10vh;
        text-align: left;
        padding-left: 5%;
        @media only screen and (min-width: 768px) and (max-width: 1366px) {
          margin: 0;
          padding: 19% 0 0 13%;
          text-align: left;
          .page-10-text-2 {
            display: flex;  
          }
        }
        @media only screen and (min-width: 1367px) {
          margin: 0;
          padding: 19% 0 0 13%;
          text-align: left;
          .page-10-text-2 {
            display: flex;  
          }
        }
      }

      // page-11
      .page-11-background {
        position: relative;
        width: 100%;
        height: 100%;
        .page-11-background-image {
          position: absolute;
          top: 0%;
          left: 0%;
          height: 100%;
          transform-origin: 200% 0;
          @media only screen and (min-width: 1280px) and (max-width: 1366px) {
            transform-origin: 50% 50%;
            height: 135%;
          }
          @media only screen and (min-width: 1367px) {
            transform-origin: 50% 50%;
            height: 150%;
          }
        }
        .page-11-background-animation-1 {
          animation: translateAnimation-1 6s ease-in-out forwards;
        }
        .page-11-background-animation-2 {
          opacity: 0;
          animation: translateAnimation-2 6s 3s ease-in-out forwards;
        }
        @keyframes translateAnimation-1 {
          0% {
            opacity: 1;
            transform: scale(1.2) translateX(100px);
          }
          50% {
            opacity: 1;
          }
          100% {
            opacity: 0;
            transform: scale(1.2) translateX(0);
          }
        }
        @keyframes translateAnimation-2 {
          0% {
            opacity: 0;
            transform: scale(1.2) translateX(100px);
          }
          50% {
            opacity: 1;
          }
          100% {
            opacity: 1;
            transform: scale(1.2) translateX(0);
          }
        }
      }
      .page-11-content {
        position: relative;
        width: 100%;
        margin-top: 10vh;
        text-align: left;
        padding-left: 5%;
        @media only screen and (min-width: 768px) and (max-width: 1366px) {
          margin: 0;
          padding: 30% 0 0 5%;
          text-align: left;
        }
        @media only screen and (min-width: 1367px) {
          margin: 0;
          padding: 10% 0 0 10%;
          text-align: left;
        }
      }

      // page-12
      .page-12-background {
        position: relative;
        width: 100%;
        height: 100%;
        .page-12-background-image {
          position: absolute;
        }
        .page-12-background-animation-1 {
          top: -8%;
          left: -30%;
          width: 130%;
          @media only screen and (min-width: 768px) and (max-width: 1024px) {
            top: -10%;
            left: -25%;
            width: 100%;
          }
          @media only screen and (min-width: 1025px) and (max-width: 1366PX) {
            top: -25%;
            left: -25%;
            width: 100%;
            animation: shiningAnimation 3s ease-in-out infinite;
          }
          @media only screen and (min-width: 1367px) {
            top: -45%;
            left: -25%;
            width: 100%;
            animation: shiningAnimation 3s ease-in-out infinite;
          }
        }
        .page-12-background-animation-2 {
          top: 10%;
          right: -30%;
          width: 100%;
          @media only screen and (min-width: 768px) and (max-width: 1024px) {
            top: 10%;
            left: 25%;
            width: 50%;
          }
          @media only screen and (min-width: 1025px) and (max-width: 1366px) {
            top: 10%;
            left: 25%;
            width: 50%;
            animation: shiningAnimation 3s .5s ease-in-out infinite;
          }
          @media only screen and (min-width: 1367px) {
            top: -10%;
            left: 25%;
            width: 50%;
            animation: shiningAnimation 3s .5s ease-in-out infinite;
          }
        }
        .page-12-background-animation-3 {
          left: 0%;
          top: 35%;
          width: 50%;
          @media only screen and (min-width: 768px) and (max-width: 1024px) {
            top: 15%;
            left: 65%;
            width: 30%;
          }
          @media only screen and (min-width: 1025px) and (max-width: 1366px) {
            top: 15%;
            left: 60%;
            width: 30%;
            animation: shiningAnimation 3s 1s ease-in-out infinite;
          }
          @media only screen and (min-width: 1367px) {
            top: 15%;
            left: 60%;
            width: 30%;
            animation: shiningAnimation 3s 1s ease-in-out infinite;
          }
        }
        @keyframes shiningAnimation {
          0% {
            opacity: 1;
          }
          50% {
            opacity: 0;
          }
          100% {
            opacity: 1;
          }
        }
      }
      .page-12-content {
        position: relative;
        margin: 20% 0 0 20px;
        text-align: left;
        @media only screen and (max-width: 320px) {
          margin: 15% 0 0 20px;
        }
        @media only screen and (min-width: 768px) and (max-width: 1366px) {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          margin: 15% 0 0 20px;
        }
        @media only screen and (min-width: 1367px) {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          margin: 15% 0 0 0;
        }
        .read-more-button-red {
          @media only screen and (max-width: 320px) {
            margin: 0;
          }
        }
        .red-round-text-wrapper {
          position: relative;
          width: 100%;
          h2 {
            font-size: 1.5rem !important;
            font-weight: bold;
          }
          @media only screen and (min-width: 768px) {
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 75px 0;
            h2 {
              font-size: 2rem !important;
              font-weight: normal;
            }
          }
          .red-round-text-1 {
            position: relative;
            padding: 5px 0;
            @media only screen and (min-width: 768px) and (max-width: 1024px) {
              box-sizing: content-box;
              border-right: solid 1px rgba(#ffffff, 0.66);
              padding: 5px 20px;
            }
            @media only screen and (min-width: 1025px) {
              box-sizing: content-box;
              border-right: solid 1px rgba(#ffffff, 0.66);
              padding: 5px 50px;
            }
          }
          .red-round-text-2 {
            position: relative;
            padding: 5px 0;
            @media only screen and (min-width: 768px) and (max-width: 1024px) {
              padding: 5px 20px;
            }
            @media only screen and (min-width: 1025px) {
              padding: 5px 50px;
            }
          }
        }
      }

      // page-13
      .page-13-content {
        position: relative;
        height: 100%;
        padding: 5% 0;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        text-align: left;
        @media only screen and (min-width: 768px) {
          justify-content: center;
        }
        .page-13-text {
          position: absolute;
          width: 100%;
          opacity: 0;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding-top: 25vh;
          padding-left: 10%;
          @media only screen and (min-width: 768px) {
            padding-left: 0;
            padding-top: 0;
            flex-direction: row;
          }
        }
        .page-13-text-2 {
          position: absolute;
          width: 100%;
          opacity: 0;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding-top: 25vh;
          padding-left: 10%;
          @media only screen and (min-width: 768px) {
            padding-top: 0;
            flex-direction: row;
          }
        }
        .source-text-wrapper {
          position: absolute;
          bottom: 12.5vh;
          left: 5%;
          font-size: 12px;
          line-height: 1.5;
          color: #b4b1b1;
          @media only screen and (min-width: 1280px) {
            display: flex;
          }
        }
        .page-13-text-align-left {
          position: relative;
          width: 100%;
          text-align: left;
          @media only screen and (min-width: 768px) {
            width: auto;
          }
        }
        .page-13-text-animation-1 {
          animation: fadeInAnimation-ending-video 5s ease-in-out;
        }
        .page-13-text-animation-2 {
          animation: fadeInAnimation-ending-video 5s 5s ease-in-out;
        }
        .page-13-text-animation-3 {
          animation: fadeInAnimation-ending-video-2 2s 10s ease-in-out forwards;
        }
        @keyframes fadeInAnimation-ending-video {
          0% {
            opacity: 0;
          }
          20% {
            opacity: 1;
          }
          80% {
            opacity: 1;
          }
          100% {
            opacity: 0;
          }
        }
        @keyframes fadeInAnimation-ending-video-2 {
          0% {
            opacity: 0;
          }
          100% {
            opacity: 1;
          }
        }
      }

      .text-black {
        h2, h3, h4, p {
          color: #000000;
        }
      }
      .text-white {
        h2, h3, h4, p {
          color: #ffffff;
        }
      }
      .read-more-button-green {
        display: inline-block;
        color: #57b09f !important;
        border-bottom: 1px solid #57b09f;
        line-height: 1.6;
        font-family: 'Lato', sans-serif;
        // font-family: Arial, 微軟正黑體, sans-serif !important;
        cursor: pointer;
        a {
          text-decoration: none;
          color: inherit;
        }
      }
      .read-more-button-red {
        display: inline-block;
        color: #ff6a6a !important;
        border-bottom: 1px solid #ff6a6a;
        line-height: 1.6;
        font-family: 'Lato', sans-serif;
        // font-family: Arial, 微軟正黑體, sans-serif !important;
        cursor: pointer;
        a {
          text-decoration: none;
          color: inherit;
        }
      }
      .element-ligh
      .element-light {
        opacity: 1;
      }
      .element-disappear {
        opacity: 0;
      }
      .full-vidoe-wrapper {
        position: relative;
        overflow: hidden;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        .ending-video {
          transform-origin: center center;
          transform: scale(1.52);
          @media only screen and (min-width: 768px) and (max-width: 1366px) {
            transform: scale(1.6);
          }
        }
        .opening-video {
          transform-origin: center center;
          transform: scale(1.25);
          @media only screen and (min-width: 768px) and (max-width: 1024px) {
            transform: scale(1);
          }
          @media only screen and (min-width: 1025px) and (max-width: 1366px) {
            transform: scale(1.5);
          }
        }
      }
    }
    .main-app::-webkit-scrollbar {
      display: none;
    }
    .general-components {
      position: relative;
      background-color: #ffffff;
      .relate {
        margin-top: 0 !important;
      }
    }
  }

  // @media only screen and (max-width: 320px) {

  // }

  // @media only screen and (min-width: 321px) and (max-width: 375px) {

  // }

  // @media only screen and (min-width: 376px) and (max-width: 411px) {

  // }

  // @media only screen and (min-width: 412px) and (max-width: 768px) {

  // }

  // @media only screen and (min-width: 769px) and (max-width: 1024px) {

  // }

  // @media only screen and (min-width: 1025px) and (max-width: 1280px) {

  // }

  // @media only screen and (min-width: 1281px) and (max-width: 1336px) {

  // }
</style>
